import { createContextUrl } from '@helios/frontend-project';
import { FinancialAccountSource, User } from '../api/user/types';
import { ROUTE } from '../routes';

export const userHasExistingRatePlan = (user: User) =>
  user?.financeAccounts?.some((account) => account.source === FinancialAccountSource.lightEnergy);

export const getProjectBuybackEnrollmentUrl = (projectId: string) =>
  `${createContextUrl(ROUTE.UTILITY_RATE_PLAN_ENROLLMENT, {
    id: projectId,
    type: 'project',
  })}&plan=recommended&returnUrl=${encodeURIComponent(`/projects/${projectId}`)}`;
